module.exports = __webpack_public_path__ + "img/symbol_7.d30933e4.png";